const COMMUNITY_TARGET_URL =
  'https://comunidade.dponet.com.br/join?invitation_token=de9a105b8ce87fbce9da52f9f60addd5144c0189-3c578fcc-615f-41b1-9431-0ad048a04706'
const community = {
  COMMUNITY_TARGET_URL,
}

export default community
